"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.resolveField = resolveField;
exports.DependencyMap = void 0;

var _lastIndexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/last-index-of"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createForOfIteratorHelper"));

var _getOwnPropertyNames = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-names"));

var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/starts-with"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _dotPropImmutable = require("dot-prop-immutable");

var _rules = require("../rules");

var _utils = require("../../utils");

var _bmFormValues = require("./bm-form-values");

var DependencyMap = /*#__PURE__*/function () {
  function DependencyMap() {
    (0, _classCallCheck2.default)(this, DependencyMap);
    this.dependencies = {};
    this.dependents = {};
  }

  (0, _createClass2.default)(DependencyMap, [{
    key: "addDependencies",
    value: function addDependencies(fullyQualifiedName, configBlock) {
      var dotPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      for (var _property in configBlock) {
        if (this._isObject(configBlock[_property])) {
          var _context2;

          if (this._isOperation(configBlock[_property])) {
            var _context;

            this._addDependency(fullyQualifiedName, (0, _concat.default)(_context = "".concat(dotPath)).call(_context, _property), configBlock[_property]);
          } else if ((0, _includes.default)(_context2 = ['options']).call(_context2, _property)) {
            var _context3;

            this.addDependencies(fullyQualifiedName, configBlock[_property], (0, _concat.default)(_context3 = "".concat(dotPath)).call(_context3, _property, "."));
          }
        }
      }
    }
  }, {
    key: "removeDependencies",
    value: function removeDependencies(fullyQualifiedName) {
      var _this = this;

      var _loop = function _loop(dependentName) {
        if ((0, _startsWith.default)(dependentName).call(dependentName, fullyQualifiedName)) {
          var propDependencies = _this.dependencies[dependentName];
          var propDependencyNames = (0, _getOwnPropertyNames.default)(propDependencies);

          var _iterator = (0, _createForOfIteratorHelper2.default)(propDependencyNames),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var dependency = _step.value;
              var propDependency = propDependencies[dependency];
              var fields = propDependency.fields;

              var _iterator2 = (0, _createForOfIteratorHelper2.default)(fields),
                  _step2;

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var _field = _step2.value;

                  var dependentPath = _this._getFullyQualifiedDotPath(dependentName, _field);

                  var dependents = _this.dependents[dependentPath];
                  var dependent = (0, _find.default)(dependents).call(dependents, function (_dependent) {
                    return _dependent.field === dependentName;
                  });
                  (0, _splice.default)(dependents).call(dependents, (0, _indexOf.default)(dependents).call(dependents, dependent), 1);

                  if (dependents.length === 0) {
                    delete _this.dependents[dependentPath];
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          delete _this.dependencies[dependentName];
        }
      };

      for (var dependentName in this.dependencies) {
        _loop(dependentName);
      }
    }
  }, {
    key: "initialize",
    value: function initialize(root) {
      return this.updateDependents(root);
    }
  }, {
    key: "updateDependents",
    value: function updateDependents(root) {
      var _this2 = this;

      var fqn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      for (var _fqn in this.dependents) {
        if ((0, _startsWith.default)(_fqn).call(_fqn, fqn)) {
          var _context4;

          root = (0, _reduce.default)(_context4 = this.dependents[_fqn]).call(_context4, function (acc, dep) {
            return _this2._updateDependent(acc, dep, _this2.dependencies);
          }, root);
        }
      }

      return root;
    }
  }, {
    key: "_updateDependent",
    value: function _updateDependent(rootFormInfo, dependent, dependencyMap) {
      var _context5,
          _context6,
          _this3 = this,
          _context7;

      var relDotPath = (0, _slice.default)(_context5 = dependent.field).call(_context5, (0, _indexOf.default)(_context6 = dependent.field).call(_context6, '.') + 1);
      var dotPath = (0, _utils.dotPathFromAncestry)(relDotPath);
      var dependentField = (0, _dotPropImmutable.get)(rootFormInfo, dotPath);
      var dependentFieldInfo = dependencyMap[dependent.field];
      var dependentProperty = dependentFieldInfo[dependent.property];
      var newVal = (0, _rules.evaluate)(dependentProperty.operation, function (_ref) {
        var fieldIdentifier = _ref.fieldIdentifier,
            propPath = _ref.propPath;
        return _this3._resolveField(rootFormInfo, dependentField, fieldIdentifier, propPath);
      });
      var fqnPath = (0, _concat.default)(_context7 = "".concat(dotPath, ".")).call(_context7, dependent.property);
      var currVal = (0, _dotPropImmutable.get)(rootFormInfo, fqnPath);

      if (currVal !== newVal) {
        rootFormInfo = (0, _dotPropImmutable.set)(rootFormInfo, fqnPath, newVal);
        _utils.invalidParents.invalid = true;
      }

      return rootFormInfo;
    }
  }, {
    key: "_resolveField",
    value: function _resolveField(rootFormInfo, baseField, fieldIdentifier, propPath) {
      if (((0, _includes.default)(fieldIdentifier).call(fieldIdentifier, 'parent.') || fieldIdentifier === 'parent') && _utils.invalidParents.invalid) {
        (0, _utils.setParents)(rootFormInfo);
      }

      return resolveField(baseField, fieldIdentifier, propPath);
    }
  }, {
    key: "_addDependency",
    value: function _addDependency(dependentFqn, dependentPropPath, operation) {
      var _this4 = this;

      this.dependencies[dependentFqn] = this.dependencies[dependentFqn] || {};
      var itemDependency = this.dependencies[dependentFqn];
      var fieldDependencies = (0, _rules.getResolvedFieldDependencies)(operation);
      itemDependency[dependentPropPath] = {
        fields: fieldDependencies,
        property: dependentPropPath,
        operation: operation
      };
      (0, _forEach.default)(fieldDependencies).call(fieldDependencies, function (fieldDependency) {
        var _context8;

        var fullyQualifiedDependency = _this4._getFullyQualifiedDotPath(dependentFqn, fieldDependency);

        _this4.dependents[fullyQualifiedDependency] = (0, _concat.default)(_context8 = _this4.dependents[fullyQualifiedDependency] || []).call(_context8, {
          field: dependentFqn,
          property: dependentPropPath
        });
      });
    }
  }, {
    key: "_isObject",
    value: function _isObject(value) {
      return Boolean(value) && (0, _typeof2.default)(value) === 'object';
    }
  }, {
    key: "_isOperation",
    value: function _isOperation(value) {
      return this._isObject(value) && Boolean(value.type) && value.type in _rules.Operator;
    }
  }, {
    key: "_getFullyQualifiedDotPath",
    value: function _getFullyQualifiedDotPath(baseDotPath, relativeDotPath) {
      while ((0, _startsWith.default)(relativeDotPath).call(relativeDotPath, 'parent.') || relativeDotPath === 'parent') {
        relativeDotPath = relativeDotPath.substr(7);
        baseDotPath = baseDotPath.substr(0, (0, _lastIndexOf.default)(baseDotPath).call(baseDotPath, '.'));
      }

      if (relativeDotPath) {
        var _context9;

        return (0, _concat.default)(_context9 = "".concat(baseDotPath, ".")).call(_context9, relativeDotPath);
      }

      return baseDotPath;
    }
  }]);
  return DependencyMap;
}();

exports.DependencyMap = DependencyMap;

function resolveField(baseField, fieldIdentifier, propPath) {
  var field = (0, _dotPropImmutable.get)(baseField, (0, _utils.dotPathFromAncestry)(fieldIdentifier));

  if ((0, _utils.isDefined)(propPath)) {
    if (propPath === 'value') return (0, _bmFormValues.getValue)(field);
    return (0, _dotPropImmutable.get)(field, propPath);
  }

  if ((0, _bmFormValues.isValuedItem)(field)) {
    return (0, _bmFormValues.getValue)(field);
  }

  return field;
}
